<template>
  <div class="page-content">
    <v-card class="mx-auto elevation-2 tabs-card mt-5">
      <v-container fluid>
        <v-row align="center" justify="space-between">
          <v-tabs v-model="activeTab" class="dashboard-tab" show-arrows next-icon="mdi-arrow-right-bold-box-outline" prev-icon="mdi-arrow-left-bold-box-outline">
            <v-tab v-if="!isSatelliteMonitor" value="studio">Studio</v-tab>
            <v-tab
              v-for="tab in (isSatelliteMonitor ? [{ value: 'satellite', label: 'Satellite' }] : tabs)"
              :key="tab.value"
              :value="tab.value"
            >
              {{ tab.label }}
            </v-tab>
          </v-tabs>
        </v-row>
      </v-container>
    </v-card>

    <v-row justify="space-around" class="mt-5">
      <v-col cols="12" md="3">
        <v-card :class="['elevation-2', activeCard === 'registerSales' ? 'active-card' : '']" @click="setActiveCard('registerSales')" style="min-height: 180px; border-radius: 6px;">
          <v-card-title class="position-relative d-flex align-center" style="padding: 8px 16px;">
            <v-icon size="28" class="mr-2">mdi-cash-register</v-icon>
            <span class="position-center" style="font-size: 16px; font-weight: 600;">Sales Entry</span>
          </v-card-title>
          <v-card-text style="padding: 4px 16px; padding-bottom: 40px;">
            <v-date-input v-model="registerSalesDate" label="Select Date" prepend-icon="" color="primary" hide-actions placeholder="yyyy/mm/dd" :readonly="editableTable" autocomplete="off"></v-date-input>
          </v-card-text>
          <v-card-actions class="justify-center mt-n4 mb-4" style="position: absolute; bottom: 0; width: 100%;">
            <v-btn
              v-if="!editableTable"
              :class="['btn-primary', activeCard === 'registerSales' ? 'active-button' : '']"
              style="padding: 0 40px; height: 36px; margin-top: 25px;font-size: 14px; background-color: #1976d2; color: white;"
              @click="registerSalesCard"
            >
              Register
            </v-btn>
            <v-btn
              v-else
              icon
              style="margin-left: 6px; background-color: #1976d2; color: white; height: 36px; width: 36px; padding: 0; margin-top: 25px;"
              @click="saveSalesData"
            >
              <v-icon size="28" style="line-height: 36px;">mdi-content-save</v-icon>
            </v-btn>
            <v-btn
              v-if="editableTable"
              icon
              style="margin-left: 6px; background-color: #e53935; color: white; height: 36px; width: 36px; padding: 0; margin-top: 25px;"
              @click="cancelRegisterSales"
            >
              <v-icon size="28" style="line-height: 36px;">mdi-close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" md="3">
        <v-card :class="['elevation-2', activeCard === 'dailySales' ? 'active-card' : '']" @click="setActiveCard('dailySales')" style="min-height: 180px; border-radius: 6px;">
          <v-card-title class="position-relative d-flex align-center" style="padding: 8px 16px;">
            <v-icon class="mr-2" size="28">mdi-calendar</v-icon>
            <span class="position-center" style="font-size: 16px; font-weight: 600;">Daily Sales</span>
          </v-card-title>
          <v-card-text style="padding: 4px 16px; padding-bottom: 40px;">
            <v-date-input v-model="dailySalesDate" label="Select Date" prepend-icon="" hide-actions placeholder="yyyy/mm/dd" autocomplete="off"></v-date-input>
          </v-card-text>
          <v-card-actions class="justify-center mt-n4 mb-4" style="position: absolute; bottom: 0; width: 100%;">
            <v-btn :class="['btn-secondary', activeCard === 'dailySales' ? 'active-button' : '']" style="padding: 0 40px; height: 36px; font-size: 14px; background-color: #000000; color: white;" @click="dailySalesCard">View</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" md="3">
        <v-card :class="['elevation-2', activeCard === 'dateRange' ? 'active-card' : '']" @click="setActiveCard('dateRange')" style="min-height: 180px; border-radius: 6px;">
          <v-card-title class="position-relative d-flex align-center" style="padding: 8px 16px;">
            <v-icon class="mr-2" size="28">mdi-calendar-multiple</v-icon>
            <span class="position-center" style="font-size: 16px; font-weight: 600;">Date Range</span>
          </v-card-title>
          <v-card-text style="padding: 4px 16px; padding-bottom: 40px;">
            <v-date-input v-model="dateSelectRange" label="Select Range" prepend-icon="" max-width="368" multiple="range" @update:modelValue="handleDateRangeSelection" ref="datePicker"/>
          </v-card-text>
          <v-card-actions class="justify-center mt-n4 mb-4" style="position: absolute; bottom: 0; width: 100%;">
            <v-btn :class="['btn-secondary', activeCard === 'dateRange' ? 'active-button' : '']" style="padding: 0 40px; height: 36px; font-size: 14px; background-color: #000000; color: white;" @click="dateRangeCard" :disabled="!dateSelectRange">View</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" md="3">
        <v-card :class="['elevation-2', activeCard === 'selectPeriod' ? 'active-card' : '']" @click="activateSelectPeriodCard" style="min-height: 180px; border-radius: 6px;">
          <v-card-title class="position-relative d-flex align-center" style="padding: 8px 16px;">
            <v-icon class="mr-2" size="28">mdi-calendar-multiple-check</v-icon>
            <span class="position-center" style="font-size: 16px; font-weight: 600;">Select Period</span>
          </v-card-title>
          <v-card-text style="padding: 4px 16px; padding-bottom: 40px;">
            <v-select
              v-model="selectedPeriod"
              :items="periodOptions"
              item-title="text"
              item-value="value"
              label="Select Period"
              outlined
              @update:modelValue="selectPeriodCard"
            ></v-select>
          </v-card-text>
          <v-card-actions class="sales-period-actions">
            <v-btn
              icon
              class="sales-period-arrow"
              :disabled="!canGoToPreviousPeriod"
              aria-label="Previous period"
              @click.stop="goToPreviousPeriod"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn
              icon
              class="sales-period-arrow"
              :disabled="!canGoToNextPeriod"
              aria-label="Next period"
              @click.stop="goToNextPeriod"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <div
      v-if="activeCard === 'registerSales' && editableTable"
      style="display: flex; justify-content: space-between; align-items: center; padding: 2px 16px; height: 48px; background: linear-gradient(180deg, #1c2321 0%, #3A4542 100%); color: white; border-radius: 6px; margin-top: 12px;"
    >
      <h2 style="font-size: 18px; font-weight: 600; color: white;">
        Registering sales for {{
          new Date(registerSalesDate).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })
        }}
      </h2>
    </div>
    
    <v-row class="mt-0" style="margin-top: 0 !important;">
      <v-col cols="12">
        <div class="table-container">
          <!-- Show message if no sales data -->
          <div v-if="salesData.length === 0">
            No sales data found for your studio during this period.
          </div>
                    <v-data-table
              density="comfortable"
              :headers="dynamicHeaders"
              :items="filteredSalesData"  
              class="elevation-1"
              fixed-header
              style="min-height: 800px; max-height: calc(100vh - 200px);"
              :items-per-page="-1"
              v-model:sort-by="sortBy"
              :must-sort="mustSort"
              :class="{ 'comfortable-mode': true }"
              hide-default-footer
            >

            <!-- Header with per-site date ranges when a period is selected -->
            <template #header.flirt4free="{ column }">
              <div class="site-header">
                <div class="site-title">{{ column.title }}</div>
                <div
                  v-if="activeCard === 'selectPeriod' && periodRanges"
                  class="site-dates"
                >
                  {{ formatWebsiteRange('flirt4free') }}
                </div>
              </div>
            </template>

            <template #header.streamate_1="{ column }">
              <div class="site-header">
                <div class="site-title">{{ column.title }}</div>
                <div
                  v-if="activeCard === 'selectPeriod' && periodRanges"
                  class="site-dates"
                >
                  {{ streamateWeekRanges.week1 }}
                </div>
              </div>
            </template>

            <template #header.streamate_2="{ column }">
              <div class="site-header">
                <div class="site-title">{{ column.title }}</div>
                <div
                  v-if="activeCard === 'selectPeriod' && periodRanges"
                  class="site-dates"
                >
                  {{ streamateWeekRanges.week2 }}
                </div>
              </div>
            </template>

            <template #header.livejasmin="{ column }">
              <div class="site-header">
                <div class="site-title">{{ column.title }}</div>
                <div
                  v-if="activeCard === 'selectPeriod' && periodRanges"
                  class="site-dates"
                >
                  {{ formatWebsiteRange('livejasmin') }}
                </div>
              </div>
            </template>

            <template #header.chaturbate="{ column }">
              <div class="site-header">
                <div class="site-title">{{ column.title }}</div>
                <div
                  v-if="activeCard === 'selectPeriod' && periodRanges"
                  class="site-dates"
                >
                  {{ formatWebsiteRange('chaturbate') }}
                </div>
              </div>
            </template>

            <template #header.stripchat="{ column }">
              <div class="site-header">
                <div class="site-title">{{ column.title }}</div>
                <div
                  v-if="activeCard === 'selectPeriod' && periodRanges"
                  class="site-dates"
                >
                  {{ formatWebsiteRange('stripchat') }}
                </div>
              </div>
            </template>

            <template #header.kwiky="{ column }">
              <div class="site-header">
                <div class="site-title">{{ column.title }}</div>
                <div
                  v-if="activeCard === 'selectPeriod' && periodRanges"
                  class="site-dates"
                >
                  {{ formatWebsiteRange('streamate') }}
                </div>
              </div>
            </template>

            <template #header.sinparty="{ column }">
              <div class="site-header"><div class="site-title">{{ column.title }}</div><div v-if="activeCard === 'selectPeriod' && periodRanges" class="site-dates">{{ formatWebsiteRange('stripchat') }}</div></div>
            </template>
            <template #header.cams="{ column }">
              <div class="site-header"><div class="site-title">{{ column.title }}</div><div v-if="activeCard === 'selectPeriod' && periodRanges" class="site-dates">{{ formatWebsiteRange('flirt4free') }}</div></div>
            </template>
            <template #header.cam4="{ column }">
              <div class="site-header"><div class="site-title">{{ column.title }}</div><div v-if="activeCard === 'selectPeriod' && periodRanges" class="site-dates">{{ formatWebsiteRange('chaturbate') }}</div></div>
            </template>
            <template #header.bonga="{ column }">
              <div class="site-header"><div class="site-title">{{ column.title }}</div><div v-if="activeCard === 'selectPeriod' && periodRanges" class="site-dates">{{ formatWebsiteRange('stripchat') }}</div></div>
            </template>

            <template v-slot:item="{ item }">
              <tr>
                <td>{{ item.stageName }}</td>
                <td v-for="column in salesColumns" :key="column.key" class="equal-width pa-0">
                  <v-text-field
                    v-if="editableTable && (!item.locked || !item.locked[column.lockKey || column.key])"
                    v-model="item[column.key]"
                    hide-details
                    density="comfortable"
                    :style="{ borderLeft: `3px solid ${column.color}`, width: '100%' }"
                    @input="normalizeInput($event, item, column.key)"
                    autocomplete="off"
                  ></v-text-field>
                  <span v-else class="sales-value">{{ formatValue(item[column.key]) }}</span>
                </td>
                <td class="equal-width pa-0">
                  <span class="sales-value">{{ formatValue(item.total) }}</span>
                </td>
              </tr>
            </template>
            <template v-slot:body.append>
              <tr class="totals-row">
                <td class="total-label">Total</td>
                <td v-for="column in salesColumns" :key="column.key" class="equal-width pa-0">
                  <span class="sales-value">{{ formatValue(totalColumn(column.key)) }}</span>
                </td>
                <td class="equal-width pa-0">
                  <span class="sales-value">{{ formatValue(grandTotal()) }}</span>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
        <v-btn
          v-if="editableTable"
          @click="saveSalesData"
          :style="floatingBtnStyle"
          icon
        >
          <v-icon size="30">mdi-content-save</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import secureAxios from '@/utils/secureAxios';
import { toast } from 'vue3-toastify';
import debounce from 'lodash/debounce';
import { getStoredUser, isSatelliteMonitor as isSatMon, defaultTabForPage } from '@/utils/satellliteMonitorRules';

const SALES_SITES = [
  { key: 'flirt4free', name: 'Flirt4Free', displayName: 'Flirt4Free', sourceKey: 'flirt4free', color: '#1EB3C6', enabled: true },
  { key: 'streamate', name: 'Streamate', displayName: 'Streamate', sourceKey: 'streamate', color: '#3399cc', enabled: true },
  { key: 'livejasmin', name: 'LiveJasmin', displayName: 'LiveJasmin', sourceKey: 'livejasmin', color: '#B8323C', enabled: true },
  { key: 'chaturbate', name: 'Chaturbate', displayName: 'Chaturbate', sourceKey: 'chaturbate', color: '#F9B661', enabled: true },
  { key: 'stripchat', name: 'Stripchat', displayName: 'StripChat', sourceKey: 'stripchat', color: '#78943d', enabled: true },
  { key: 'kwiky', name: 'Kwiky', displayName: 'Kwiky', sourceKey: 'streamate', color: '#8e44ad', enabled: false },
  { key: 'sinparty', name: 'Sin Party', displayName: 'Sin Party', sourceKey: 'stripchat', color: '#d96b8d', enabled: false },
  { key: 'cams', name: 'Cams', displayName: 'Cams', sourceKey: 'flirt4free', color: '#00a6a6', enabled: false },
  { key: 'cam4', name: 'Cam4', displayName: 'Cam4', sourceKey: 'chaturbate', color: '#f08a24', enabled: false },
  { key: 'bonga', name: 'Bonga', displayName: 'Bonga', sourceKey: 'stripchat', color: '#7356a8', enabled: false },
];

export default {
  name: "SalesPage",
  data() {
    return {
      user: getStoredUser(),
      salesData: [],
      activeTab: 'studio',
      activeCard: 'dateRange',
      tabs: [
        { value: 'morning', label: 'Morning' },
        { value: 'evening', label: 'Evening' },
        { value: 'night', label: 'Night' },
        { value: 'satellite', label: 'Satellite' },
        { value: 'active', label: 'Active' },
      ],
      registerSalesDate: null,
      dailySalesDate: new Date(),
      dateSelectRange: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()],
      periods: [],
      periodOptions: [],
      selectedPeriod: null,
      editableTable: false,
      sortBy: [{ key: 'stageName', order: 'asc' }],
      mustSort: true,
      isDocked: false,
      periodRanges: null,
      siteCatalog: SALES_SITES.map(site => ({ ...site })),
    };
  },
  computed: {
    isSatelliteMonitor() {
      return isSatMon(this.user);
    },
    selectedPeriodIndex() {
      return this.periodOptions.findIndex(period => Number(period.value) === Number(this.selectedPeriod));
    },
    canGoToPreviousPeriod() {
      return this.selectedPeriodIndex > 0;
    },
    canGoToNextPeriod() {
      return this.selectedPeriodIndex !== -1 && this.selectedPeriodIndex < this.periodOptions.length - 1;
    },
    dynamicHeaders() {
      return [
        { title: 'Stage Name', key: 'stageName', sortable: true },
        ...this.salesColumns.map(column => ({ title: column.displayName, key: column.key, sortable: true })),
        { title: 'Total', key: 'total', sortable: true },
      ];
    },
    visibleSites() {
      return this.siteCatalog.filter(site => site.enabled || this.salesData.some((row) => {
        if (site.key === 'streamate' && this.activeCard === 'selectPeriod') {
          return Number(row.streamate_1 || 0) !== 0 || Number(row.streamate_2 || 0) !== 0;
        }
        return Number(row[site.key] || 0) !== 0;
      }));
    },
    salesColumns() {
      return this.visibleSites.flatMap((site) => {
        if (site.key === 'streamate' && this.activeCard === 'selectPeriod') {
          return [
            { ...site, key: 'streamate_1', displayName: 'Streamate 1', lockKey: 'streamate' },
            { ...site, key: 'streamate_2', displayName: 'Streamate 2', lockKey: 'streamate' },
          ];
        }
        return [site];
      });
    },
    floatingBtnStyle() {
      return {
        position: this.isDocked ? 'static' : 'fixed',
        bottom: this.isDocked ? 'auto' : '24px',
        right: '24px',
        backgroundColor: '#1976d2',
        color: '#fff',
        zIndex: 10,
      };
    },
    streamateWeekRanges() {
      if (!this.periodRanges || !this.periodRanges.streamate) {
        return { week1: '-', week2: '-' };
      }

      const range = this.periodRanges.streamate;
      if (!range.start_date || !range.end_date) {
        return { week1: '-', week2: '-' };
      }

      const cleanStart = this.cleanDate(range.start_date);
      const cleanEnd = this.cleanDate(range.end_date);

      if (!cleanStart || !cleanEnd) {
        return { week1: '-', week2: '-' };
      }

      const start = new Date(cleanStart + 'T00:00:00');
      const end = new Date(cleanEnd + 'T00:00:00');

      if (isNaN(start) || isNaN(end)) {
        return { week1: '-', week2: '-' };
      }

      const week1Start = new Date(start);
      const week1End = new Date(start);
      week1End.setDate(week1End.getDate() + 6);

      const week2Start = new Date(start);
      week2Start.setDate(week2Start.getDate() + 7);
      const week2End = new Date(end);

      // Ensure we don't go past the real end date
      if (week1End > end) week1End.setTime(end.getTime());
      if (week2Start > week2End) week2Start.setTime(week2End.getTime());

      return {
        week1: this.formatRangeFromDates(week1Start, week1End),
        week2: this.formatRangeFromDates(week2Start, week2End),
      };
    },
    // NEW: Add filteredSalesData to handle active/sales visibility
    filteredSalesData() {
      return this.salesData.filter(item => {
        const hasSales = this.hasSales(item);
        const isActive = item.status === 'Active';

        // Only include models that are active or have sales
        if (!hasSales && !isActive) return false;

        // Satellite monitors: always restrict to Satellite models only
        if (this.isSatelliteMonitor) {
          return item.location === 'Satellite';
        }

        switch (this.activeTab) {
          case 'studio':
            return ['Morning', 'Evening', 'Night'].includes(item.location);
          case 'morning':
            return item.location === 'Morning';
          case 'evening':
            return item.location === 'Evening';
          case 'night':
            return item.location === 'Night';
          case 'satellite':
            return item.location === 'Satellite';
          case 'active':
            return isActive;
          default:
            return true;
        }
      });
    },
  },
  created() {
    // Force default tab for satellite monitors
    const forcedTab = typeof defaultTabForPage === 'function' ? defaultTabForPage('sales', this.user) : null;
    if (forcedTab) {
      this.activeTab = forcedTab;
    } else if (this.isSatelliteMonitor) {
      this.activeTab = 'satellite';
    }

    this.initialize();
  },
  watch: {
    dateSelectRange(newRange) {
      if (newRange.length === 2) {
        this.viewRangeSales();
      }
    },
    activeTab(newTab) {
      // Satellite monitors should never leave Satellite tab
      if (this.isSatelliteMonitor && newTab !== 'satellite') {
        this.activeTab = 'satellite';
        return;
      }


      // Refresh based on the current active card
      if (this.activeCard === 'selectPeriod') {
        this.viewPeriodSales(); // call the period endpoint again
      } else if (this.activeCard === 'dailySales') {
        this.viewDailySales();
      } else if (this.activeCard === 'dateRange') {
        this.viewRangeSales();
      }
      // If we're on registerSales, we don't auto-refresh from backend
    }
  },
  methods: {
    async fetchSiteConfiguration() {
      try {
        const { data } = await secureAxios.get('/api/config/sites');
        const configured = new Map((data?.sites || []).map(site => [site.key, site]));
        this.siteCatalog = SALES_SITES.map((site) => ({
          ...site,
          ...(configured.get(site.key) || {}),
          displayName: configured.get(site.key)?.displayName || site.displayName,
          color: site.color,
          enabled: configured.has(site.key) ? Boolean(configured.get(site.key).enabled) : site.enabled,
        }));
      } catch (error) {
        console.error('Unable to load studio site configuration:', error?.message || error);
      }
    },
    getLocationParams() {
      const params = {};

      // Satellite monitors: always restricted
      if (this.isSatelliteMonitor) {
        params.location = 'satellite';
        return params;
      }

      // Studio tab should mean: Morning + Evening + Night only
      if (this.activeTab === 'studio') {
        params.locations = 'morning,evening,night';
        return params;
      }

      // Specific location tabs
      if (['morning', 'evening', 'night', 'satellite'].includes(this.activeTab)) {
        params.location = this.activeTab;
        return params;
      }

      // Active tab (kept for compatibility)
      if (this.activeTab === 'active') {
        params.status = 'Active';
      }

      return params;
    },
    async fetchPeriods() {
      try {
        const response = await secureAxios.get('/api/sales/periods');
        this.periods = response.data;
        this.periodOptions = this.periods.map(period => ({
          value: period.id,
          text: period.name,
          payment_date: period.payment_date 
        }));

        // Normalize today to local date (no UTC shifting)
        const todayStr = new Date().toISOString().split('T')[0];
        const currentPeriod = this.periodOptions.find(period => {
          const paymentStr = String(period.payment_date).split('T')[0]; // YYYY-MM-DD

          // cutoff = payment_date + 1 day
          const cutoff = new Date(paymentStr + 'T00:00:00');
          cutoff.setDate(cutoff.getDate() + 1);
          const cutoffStr = cutoff.toISOString().split('T')[0];

          return todayStr < cutoffStr;
        }) || this.periodOptions[this.periodOptions.length - 1];

        this.selectedPeriod = currentPeriod.value;
      } catch (error) {
        console.error('❌ Error fetching periods:', error?.message || error);
        toast.error('Failed to fetch periods');
      }
    },
    cleanDate(d) {
      if (!d || typeof d !== 'string') return null;
      return d.split('T')[0].split(' ')[0];
    },
    formatValue(value) {
      const num = parseFloat(value);
      if (value === null || value === "" || isNaN(num) || num === 0) {
        return "";
      }
      return "$" + num.toFixed(2);
    },
    formatRangeFromDates(start, end) {
      if (!start || !end || isNaN(start) || isNaN(end)) return '';

      const sameMonth =
        start.getMonth() === end.getMonth() &&
        start.getFullYear() === end.getFullYear();

      const startMonth = start.toLocaleString('en-US', { month: 'short' });
      const endMonth = end.toLocaleString('en-US', { month: 'short' });

      if (sameMonth) {
        // Example: "Dec 1 - 14"
        return `${startMonth} ${start.getDate()} - ${end.getDate()}`;
      } else {
        // Example: "Nov 30 - Dec 13"
        return `${startMonth} ${start.getDate()} - ${endMonth} ${end.getDate()}`;
      }
    },
    formatWebsiteRange(siteKey) {
      if (!this.periodRanges || !this.periodRanges[siteKey]) return '';
      const range = this.periodRanges[siteKey];
      if (!range.start_date || !range.end_date) return '';

      const cleanStart = this.cleanDate(range.start_date);
      const cleanEnd = this.cleanDate(range.end_date);

      if (!cleanStart || !cleanEnd) return '';

      const start = new Date(cleanStart + 'T00:00:00');
      const end = new Date(cleanEnd + 'T00:00:00');

      if (isNaN(start) || isNaN(end)) return '';

      return this.formatRangeFromDates(start, end);
    },
    normalizeInput(event, item, field) {
      let value = event.target.value || event;
      if (typeof value === 'string') {
        value = value.replace(',', '.');
        item[field] = value.match(/^-?\d*\.?\d{0,2}$/) ? value : parseFloat(value).toFixed(2);
      }
      item.total = this.calculateTotal(item);
    },
    handleDateRangeSelection(newRange) {
      if (newRange.length === 2) {
        this.$nextTick(() => {
          if (this.$refs.datePicker) {
            this.$refs.datePicker.isActive = false;
          }
        });
      }
    },
    setActiveCard(card) {
      this.activeCard = card;
      if (card !== 'selectPeriod') {
        // Hide ranges when not in Select Period mode
        this.periodRanges = null;
      }
    },
    async registerSalesCard() {
      this.setActiveCard('registerSales');
      await this.registerSales();
    },
    async dailySalesCard() {
      this.setActiveCard('dailySales');
      await this.viewDailySales();
    },
    async dateRangeCard() {
      this.setActiveCard('dateRange');
      await this.viewRangeSales();
    },
    async activateSelectPeriodCard(event) {
      if (event?.target?.closest?.('.v-input, .v-btn')) return;
      if (this.activeCard === 'selectPeriod') return;
      this.setActiveCard('selectPeriod');
      await this.viewPeriodSales();
    },
    selectPeriodCard: debounce(async function() {
      this.setActiveCard('selectPeriod');
      await this.viewPeriodSales();
    }, 300),
    async goToPreviousPeriod() {
      if (!this.canGoToPreviousPeriod) return;
      this.selectedPeriod = this.periodOptions[this.selectedPeriodIndex - 1].value;
      this.setActiveCard('selectPeriod');
      await this.viewPeriodSales();
    },
    async goToNextPeriod() {
      if (!this.canGoToNextPeriod) return;
      this.selectedPeriod = this.periodOptions[this.selectedPeriodIndex + 1].value;
      this.setActiveCard('selectPeriod');
      await this.viewPeriodSales();
    },
    async registerSales() {
      if (!this.registerSalesDate) {
        toast.error('Please select a date before registering sales');
        return;
      }
      const formattedDate = new Date(this.registerSalesDate).toISOString().split("T")[0];
      try {
        const salesResponse = await secureAxios.get(`/api/sales/date/${formattedDate}`, { params: this.getLocationParams() });
        const rows = salesResponse.data;

        // If lockedPeriods is available, build locked object inclusively
        // Fallback: use row.locked as before if not using lockedPeriods
        // Example: lockedPeriods = { flirt4free: [{start: '2024-06-01', end: '2024-06-10'}, ...], ... }
        const lockedPeriods = rows.lockedPeriods || null; // If API supplies lockedPeriods

        this.salesData = rows.map(row => {
          let locked;
          if (lockedPeriods && typeof lockedPeriods === 'object') {
            // Use JS Date comparisons for inclusivity
            locked = {};
            const selectedDate = formattedDate; // YYYY-MM-DD
            Object.keys(lockedPeriods).forEach(site => {
              locked[site] = false;
              if (Array.isArray(lockedPeriods[site])) {
                lockedPeriods[site].forEach(range => {
                  // Use native JS date comparison, inclusive
                  const selected = new Date(selectedDate);
                  const startDate = new Date(range.start);
                  const endDate = new Date(range.end);
                  if (selected >= startDate && selected <= endDate) {
                    locked[site] = true;
                  }
                });
              }
            });
          } else if (row.locked && typeof row.locked === 'object') {
            locked = {
              flirt4free: !!row.locked.flirt4free,
              streamate: !!row.locked.streamate,
              livejasmin: !!row.locked.livejasmin,
              chaturbate: !!row.locked.chaturbate,
              stripchat: !!row.locked.stripchat,
              kwiky: !!row.locked.kwiky,
              sinparty: !!row.locked.sinparty,
              cams: !!row.locked.cams,
              cam4: !!row.locked.cam4,
              bonga: !!row.locked.bonga,
              xlove: !!row.locked.xlove
            };
          } else {
            locked = {
              flirt4free: false,
              streamate: false,
              livejasmin: false,
              chaturbate: false,
              stripchat: false,
              kwiky: false,
              sinparty: false,
              cams: false,
              cam4: false,
              bonga: false,
              xlove: false
            };
          }
          return {
            modelId: row.model_id,
            stageName: row.stage_name,
            status: row.status,
            location: row.location || 'Unknown',
            flirt4free: parseFloat(row.flirt4free) > 0 ? parseFloat(row.flirt4free).toFixed(2) : "",
            streamate: parseFloat(row.streamate) > 0 ? parseFloat(row.streamate).toFixed(2) : "",
            livejasmin: parseFloat(row.livejasmin) > 0 ? parseFloat(row.livejasmin).toFixed(2) : "",
            chaturbate: parseFloat(row.chaturbate) > 0 ? parseFloat(row.chaturbate).toFixed(2) : "",
            stripchat: parseFloat(row.stripchat) > 0 ? parseFloat(row.stripchat).toFixed(2) : "",
            kwiky: parseFloat(row.kwiky) > 0 ? parseFloat(row.kwiky).toFixed(2) : "",
            sinparty: parseFloat(row.sinparty) > 0 ? parseFloat(row.sinparty).toFixed(2) : "",
            cams: parseFloat(row.cams) > 0 ? parseFloat(row.cams).toFixed(2) : "",
            cam4: parseFloat(row.cam4) > 0 ? parseFloat(row.cam4).toFixed(2) : "",
            bonga: parseFloat(row.bonga) > 0 ? parseFloat(row.bonga).toFixed(2) : "",
            xlove: parseFloat(row.xlove) > 0 ? parseFloat(row.xlove).toFixed(2) : "",
            locked,
            total: 0
          };
        }).map(item => {
          item.total = this.calculateTotal(item);
          return item;
        });
        this.editableTable = true;
      } catch (error) {
        console.error("❌ Error registering sales:", error?.message || error);
        toast.error('Failed to register sales');
      }
    },
    async viewDailySales() {
    if (!this.dailySalesDate) {
      toast.error('Please select a date');
      return;
    }
    // Handle both Date and string inputs
    const dateObj = this.dailySalesDate instanceof Date
      ? this.dailySalesDate
      : new Date(this.dailySalesDate);
    if (isNaN(dateObj)) {
      toast.error('Invalid date selected');
      return;
    }
    const formattedDate = dateObj.toISOString().split("T")[0];
    try {
      const salesResponse = await secureAxios.get(`/api/sales/date/${formattedDate}`, { params: this.getLocationParams() });
      this.salesData = salesResponse.data.map(row => ({
        modelId: row.model_id,
        stageName: row.stage_name,
        status: row.status,
        location: row.location,
        flirt4free: parseFloat(row.flirt4free) > 0 ? parseFloat(row.flirt4free).toFixed(2) : "",
        streamate: parseFloat(row.streamate) > 0 ? parseFloat(row.streamate).toFixed(2) : "",
        livejasmin: parseFloat(row.livejasmin) > 0 ? parseFloat(row.livejasmin).toFixed(2) : "",
        chaturbate: parseFloat(row.chaturbate) > 0 ? parseFloat(row.chaturbate).toFixed(2) : "",
        stripchat: parseFloat(row.stripchat) > 0 ? parseFloat(row.stripchat).toFixed(2) : "",
        kwiky: parseFloat(row.kwiky) > 0 ? parseFloat(row.kwiky).toFixed(2) : "",
        sinparty: parseFloat(row.sinparty) > 0 ? parseFloat(row.sinparty).toFixed(2) : "",
        cams: parseFloat(row.cams) > 0 ? parseFloat(row.cams).toFixed(2) : "",
        cam4: parseFloat(row.cam4) > 0 ? parseFloat(row.cam4).toFixed(2) : "",
        bonga: parseFloat(row.bonga) > 0 ? parseFloat(row.bonga).toFixed(2) : "",
        xlove: parseFloat(row.xlove) > 0 ? parseFloat(row.xlove).toFixed(2) : "",
        total: 0,
      })).map(item => {
        item.total = this.calculateTotal(item);
        return item;
      });
      this.editableTable = false;
    } catch (error) {
      console.error('❌ Error fetching daily sales:', error?.message || error);
      toast.error('Failed to fetch daily sales');
    }
  },
    async viewRangeSales() {
      if (!this.dateSelectRange || this.dateSelectRange.length < 2) {
        toast.error('Please select a valid date range');
        return;
      }
      const dateArray = [...this.dateSelectRange].map(d => new Date(d)).sort((a, b) => a - b);
      // Use local date formatting to avoid time zone issues
      const startDate = dateArray[0].toLocaleDateString('en-CA'); // YYYY-MM-DD
      const endDate = dateArray[dateArray.length - 1].toLocaleDateString('en-CA'); // YYYY-MM-DD
      // Debug log for actual start and end date being sent
      try {
        // Use updated /range endpoint
        const salesResponse = await secureAxios.get(`/api/sales/range/${startDate}/${endDate}`, { params: this.getLocationParams() });
        this.salesData = salesResponse.data.map(row => ({
          modelId: row.model_id,
          stageName: row.stage_name,
          status: row.status,
          location: row.location,
          flirt4free: row.flirt4free ? parseFloat(row.flirt4free).toFixed(2) : "",
          streamate: row.streamate ? parseFloat(row.streamate).toFixed(2) : "",
          livejasmin: row.livejasmin ? parseFloat(row.livejasmin).toFixed(2) : "",
          chaturbate: row.chaturbate ? parseFloat(row.chaturbate).toFixed(2) : "",
          stripchat: row.stripchat ? parseFloat(row.stripchat).toFixed(2) : "",
          kwiky: row.kwiky ? parseFloat(row.kwiky).toFixed(2) : "",
          sinparty: row.sinparty ? parseFloat(row.sinparty).toFixed(2) : "",
          cams: row.cams ? parseFloat(row.cams).toFixed(2) : "",
          cam4: row.cam4 ? parseFloat(row.cam4).toFixed(2) : "",
          bonga: row.bonga ? parseFloat(row.bonga).toFixed(2) : "",
          xlove: row.xlove ? parseFloat(row.xlove).toFixed(2) : "",
          total: 0
        })).map(item => {
          item.total = this.calculateTotal(item);
          return item;
        });
        this.editableTable = false;
      } catch (error) {
        console.error("❌ Error fetching range sales:", error?.message || error);
        toast.error('Failed to fetch range sales');
      }
    },
    async viewPeriodSales() {
      if (!this.selectedPeriod) {
        this.salesData = this.filterModelsByTab(await secureAxios.get('/models').then(res => res.data))
          .map(model => {
            const item = {
              modelId: model.id,
              stageName: model.stageName,
              status: model.status,
              location: model.location || 'Unknown',
              flirt4free: "",
              streamate_1: "",
              streamate_2: "",
              streamate: "",
              livejasmin: "",
              chaturbate: "",
              stripchat: "",
              kwiky: "",
              sinparty: "",
              cams: "",
              cam4: "",
              bonga: "",
              xlove: "",
              total: 0
            };
            item.total = this.calculateTotal(item);
            return item;
          });
        this.editableTable = false;
        return;
      }
      try {
        const salesResponse = await secureAxios.get(`/api/sales/period/${this.selectedPeriod}`, { params: this.getLocationParams() });
        const data = salesResponse.data;

        let rows = [];
        let ranges = null;

        // Support both old (array) and new ({ rows, ranges }) formats
        if (Array.isArray(data)) {
          rows = data;
          ranges = null;
        } else if (data && Array.isArray(data.rows)) {
          rows = data.rows;
          ranges = data.ranges || null;
        } else {
          console.warn('Unexpected /api/sales/period payload shape');
        }

        // Save ranges for the info bar (may be null if old format)
        this.periodRanges = ranges;

        this.salesData = (rows || []).map(row => ({
          modelId: row.model_id,
          stageName: row.stage_name,
          status: row.status,
          location: row.location,
          flirt4free: row.flirt4free ? parseFloat(row.flirt4free).toFixed(2) : "",
          streamate_1: row.streamate_1 ? parseFloat(row.streamate_1).toFixed(2) : "",
          streamate_2: row.streamate_2 ? parseFloat(row.streamate_2).toFixed(2) : "",
          streamate: row.streamate ? parseFloat(row.streamate).toFixed(2) : "",
          livejasmin: row.livejasmin ? parseFloat(row.livejasmin).toFixed(2) : "",
          chaturbate: row.chaturbate ? parseFloat(row.chaturbate).toFixed(2) : "",
          stripchat: row.stripchat ? parseFloat(row.stripchat).toFixed(2) : "",
          kwiky: row.kwiky ? parseFloat(row.kwiky).toFixed(2) : "",
          sinparty: row.sinparty ? parseFloat(row.sinparty).toFixed(2) : "",
          cams: row.cams ? parseFloat(row.cams).toFixed(2) : "",
          cam4: row.cam4 ? parseFloat(row.cam4).toFixed(2) : "",
          bonga: row.bonga ? parseFloat(row.bonga).toFixed(2) : "",
          xlove: row.xlove ? parseFloat(row.xlove).toFixed(2) : "",
          total: 0
        })).map(item => {
          item.total = this.calculateTotal(item);
          return item;
        });
        this.editableTable = false;
      } catch (error) {
        console.error('❌ Error fetching period sales:', error?.message || error);
        toast.error('Failed to fetch period sales');
      }
    },
    async initialize() {
      try {
        await this.fetchSiteConfiguration();
        await this.fetchPeriods();

        // Default behavior:
        // - If Select Period card is active, show period sales
        // - Otherwise, keep existing behavior
        if (this.activeCard === 'selectPeriod') {
          await this.viewPeriodSales();
        } else {
          await this.viewRangeSales();
        }

      } catch (error) {
        console.error('Error during initialization:', error?.message || error);
        toast.error('Failed to initialize sales data');
      }
    },
    filterModelsByTab(models) {
      let filteredModels = models.filter(model => model.status === 'Active');
      switch (this.activeTab) {
        case 'studio':
          filteredModels = filteredModels.filter(model => ['Morning', 'Evening', 'Night'].includes(model.location));
          break;
        case 'morning':
          filteredModels = filteredModels.filter(model => model.location === 'Morning');
          break;
        case 'evening':
          filteredModels = filteredModels.filter(model => model.location === 'Evening');
          break;
        case 'night':
          filteredModels = filteredModels.filter(model => model.location === 'Night');
          break;
        case 'satellite':
          filteredModels = filteredModels.filter(model => model.location === 'Satellite');
          break;
        case 'active':
          break;
        default:
          break;
      }
      return filteredModels;
    },
    mergeSalesData(models, sales) {
      const salesMap = {};
      sales.forEach(sale => {
        const modelId = sale.model_id;
        if (!salesMap[modelId]) {
          salesMap[modelId] = {
            modelId: modelId,
            stageName: sale.stage_name,
            flirt4free: "",
            streamate: "",
            livejasmin: "",
            chaturbate: "",
            stripchat: "",
            kwiky: "",
            sinparty: "",
            cams: "",
            cam4: "",
            bonga: "",
            xlove: "",
            total: 0
          };
        }
        const flirt4free = parseFloat(salesMap[modelId].flirt4free || 0) + parseFloat(sale.flirt4free || 0);
        salesMap[modelId].flirt4free = flirt4free ? flirt4free.toFixed(2) : "";
        const streamate = parseFloat(salesMap[modelId].streamate || 0) + parseFloat(sale.streamate || 0);
        salesMap[modelId].streamate = streamate ? streamate.toFixed(2) : "";
        const livejasmin = parseFloat(salesMap[modelId].livejasmin || 0) + parseFloat(sale.livejasmin || 0);
        salesMap[modelId].livejasmin = livejasmin ? livejasmin.toFixed(2) : "";
        const chaturbate = parseFloat(salesMap[modelId].chaturbate || 0) + parseFloat(sale.chaturbate || 0);
        salesMap[modelId].chaturbate = chaturbate ? chaturbate.toFixed(2) : "";
        const stripchat = parseFloat(salesMap[modelId].stripchat || 0) + parseFloat(sale.stripchat || 0);
        salesMap[modelId].stripchat = stripchat ? stripchat.toFixed(2) : "";
        const kwiky = parseFloat(salesMap[modelId].kwiky || 0) + parseFloat(sale.kwiky || 0);
        salesMap[modelId].kwiky = kwiky ? kwiky.toFixed(2) : "";
        const sinparty = parseFloat(salesMap[modelId].sinparty || 0) + parseFloat(sale.sinparty || 0);
        salesMap[modelId].sinparty = sinparty ? sinparty.toFixed(2) : "";
        const cams = parseFloat(salesMap[modelId].cams || 0) + parseFloat(sale.cams || 0);
        salesMap[modelId].cams = cams ? cams.toFixed(2) : "";
        const cam4 = parseFloat(salesMap[modelId].cam4 || 0) + parseFloat(sale.cam4 || 0);
        salesMap[modelId].cam4 = cam4 ? cam4.toFixed(2) : "";
        const bonga = parseFloat(salesMap[modelId].bonga || 0) + parseFloat(sale.bonga || 0);
        salesMap[modelId].bonga = bonga ? bonga.toFixed(2) : "";
        const xlove = parseFloat(salesMap[modelId].xlove || 0) + parseFloat(sale.xlove || 0);
        salesMap[modelId].xlove = xlove ? xlove.toFixed(2) : "";
        salesMap[modelId].total = this.calculateTotal(salesMap[modelId]);
      });
      const merged = models.map(model => {
        const item = salesMap[model.id] || {
          modelId: model.id,
          stageName: model.stageName,
          flirt4free: "",
          streamate: "",
          livejasmin: "",
          chaturbate: "",
          stripchat: "",
          kwiky: "",
          sinparty: "",
          cams: "",
          cam4: "",
          bonga: "",
          xlove: "",
          total: 0
        };
        item.total = this.calculateTotal(item);
        return item;
      });
      return merged;
    },
    // NEW: Add hasSales helper
    hasSales(item) {
      const fields = this.activeCard === 'selectPeriod'
        ? ['flirt4free', 'streamate_1', 'streamate_2', 'livejasmin', 'chaturbate', 'stripchat', 'kwiky', 'sinparty', 'cams', 'cam4', 'bonga', 'xlove']
        : ['flirt4free', 'streamate', 'livejasmin', 'chaturbate', 'stripchat', 'kwiky', 'sinparty', 'cams', 'cam4', 'bonga', 'xlove'];
      return fields.some(field => parseFloat(item[field]) > 0);
    },
    calculateTotal(item) {
      const streamateTotal = this.activeCard === 'selectPeriod'
        ? (parseFloat(item.streamate_1) || 0) + (parseFloat(item.streamate_2) || 0)
        : parseFloat(item.streamate) || 0;
      return [
        item.flirt4free,
        streamateTotal,
        item.livejasmin,
        item.chaturbate,
        item.stripchat,
        item.kwiky,
        item.sinparty,
        item.cams,
        item.cam4,
        item.bonga,
        item.xlove
      ].reduce((acc, val) => acc + (parseFloat(val) || 0), 0);
    },
    async saveSalesData() {
      try {
        if (!this.registerSalesDate) {
          toast.error('Please select a date before saving sales');
          return;
        }

        const formattedDate = new Date(this.registerSalesDate).toISOString().split("T")[0];

        // Fetch original data so we know what previously had sales
        const originalResponse = await secureAxios.get(`/api/sales/date/${formattedDate}`);
        const originalData = originalResponse.data;

        const updates = [];

        this.salesData.forEach(item => {
          const salesValues = {
            model_id: item.modelId,
            stage_name: item.stageName,
            date: formattedDate,
            flirt4free: parseFloat(item.flirt4free) || 0,
            streamate: parseFloat(item.streamate) || 0,
            livejasmin: parseFloat(item.livejasmin) || 0,
            chaturbate: parseFloat(item.chaturbate) || 0,
            stripchat: parseFloat(item.stripchat) || 0,
            kwiky: parseFloat(item.kwiky) || 0,
            sinparty: parseFloat(item.sinparty) || 0,
            cams: parseFloat(item.cams) || 0,
            cam4: parseFloat(item.cam4) || 0,
            bonga: parseFloat(item.bonga) || 0,
            xlove: parseFloat(item.xlove) || 0,
          };

          const original = originalData.find(o => o.model_id === item.modelId) || {
            flirt4free: 0,
            streamate: 0,
            livejasmin: 0,
            chaturbate: 0,
            stripchat: 0,
            kwiky: 0,
            sinparty: 0,
            cams: 0,
            cam4: 0,
            bonga: 0,
            xlove: 0,
          };

          const currentArray = [
            salesValues.flirt4free,
            salesValues.streamate,
            salesValues.livejasmin,
            salesValues.chaturbate,
            salesValues.stripchat,
            salesValues.kwiky,
            salesValues.sinparty,
            salesValues.cams,
            salesValues.cam4,
            salesValues.bonga,
            salesValues.xlove,
          ];

          const originalArray = [
            original.flirt4free || 0,
            original.streamate || 0,
            original.livejasmin || 0,
            original.chaturbate || 0,
            original.stripchat || 0,
            original.kwiky || 0,
            original.sinparty || 0,
            original.cams || 0,
            original.cam4 || 0,
            original.bonga || 0,
            original.xlove || 0,
          ];

          const hasNonZero = currentArray.some(value => Math.abs(parseFloat(value) || 0) >= 0.01);
          const wasNonZero = originalArray.some(value => Math.abs(parseFloat(value) || 0) >= 0.01);

          // We only need to send rows that either currently have sales
          // or previously had sales (so they can be zeroed out)
          if (hasNonZero || wasNonZero) {
            updates.push(salesValues);
          }
        });


        if (updates.length > 0) {
          const updateResponse = await secureAxios.post('/api/sales', updates);
          toast.success(`Sales data saved successfully for ${new Date(this.registerSalesDate).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}`);
        } else {
          toast.info('No sales changes to save.');
        }

        // Reset state and switch to Daily Sales view for the saved date
        this.editableTable = false;
        this.dailySalesDate = new Date(this.registerSalesDate);
        this.registerSalesDate = null;
        this.salesData = [];
        this.activeCard = 'dailySales';
        await this.viewDailySales();
      } catch (error) {
        console.error('❌ Error saving sales data:', error?.message || error);
        toast.error('Failed to save sales data');
      }
    },
    totalColumn(field) {
      if (field === 'total') return this.grandTotal();
      return this.filteredSalesData.reduce((sum, item) => sum + (parseFloat(item[field]) || 0), 0).toFixed(2);
    },
    grandTotal() {
      return this.filteredSalesData.reduce((sum, item) => sum + parseFloat(this.calculateTotal(item) || 0), 0).toFixed(2);
    },
    handleScroll() {
      const container = document.querySelector('.table-container');
      if (!container) return;
      const bottomGap = container.scrollHeight - container.scrollTop - container.clientHeight;
      this.isDocked = bottomGap < 60;
    },
    async cancelRegisterSales() {
      if (this.registerSalesDate) {
        this.dailySalesDate = new Date(this.registerSalesDate); // Copy as Date
      } else {
        this.dailySalesDate = new Date(); // Fallback to today
      }
      this.registerSalesDate = null;
      this.editableTable = false;
      this.salesData = [];
      this.activeCard = 'dailySales';
      await this.viewDailySales();
      toast.info("Sales registration canceled.");
    },
  },
  mounted() {
    const container = document.querySelector('.table-container');
    if (container) container.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    const container = document.querySelector('.table-container');
    if (container) container.removeEventListener('scroll', this.handleScroll);
  }
};
</script>

<style scoped>
.dashboard-tab .v-tab {
  background-color: white;
  color: #2C74B3;
}
.active-card {
  border: 2px solid #1976d2;
}
.v-card-title {
  position: relative;
}
.position-center {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.sales-period-actions {
  justify-content: center;
  gap: 18px;
  margin-top: -16px;
  margin-bottom: 12px;
  position: absolute;
  bottom: 0;
  width: 100%;
}

.sales-period-arrow {
  background: #1976d2 !important;
  color: white !important;
  height: 36px !important;
  width: 44px !important;
}

.sales-period-arrow:disabled {
  background: #d8e1ec !important;
  color: #8391a3 !important;
}

.sales-period-arrow:deep(.v-icon) {
  color: white !important;
}

.v-data-table tbody tr:nth-child(odd) {
  background-color: #ffffff;
}
.v-data-table tbody tr:nth-child(even) {
  background-color: #f0f4f8;
}

.totals-row {
  position: sticky;
  bottom: 0;
  background-color: #f5f5f5;
}
.totals-row td {
  font-weight: bold;
  text-align: left;
}

:deep(.equal-width) {
  width: 160px;
  min-width: 160px;
  max-width: 160px;
}

:deep(.v-data-table table) {
  table-layout: fixed;
}

:deep(.v-data-table th:first-child),
:deep(.v-data-table td:first-child) {
  width: 220px;
  min-width: 220px;
  max-width: 220px;
}
.sales-value {
  display: inline-block;
  width: 100%;
  padding: 0 16px; /* top/right/bottom/left */
}
.table-container {
  max-height: calc(100vh - 200px); /* or 800px */
  overflow-y: auto;
  position: relative; /* ← THIS is key */
}
.site-dates {
  font-size: 12px; /* reduced size */
  font-weight: 400; /* reduced weight */
  opacity: 0.85;
}
</style>
